'use strict';

var React = require('react');

var SvgSmileySadMajor = function SvgSmileySadMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 10c0-5.514 4.486-10 10-10s10 4.486 10 10-4.486 10-10 10-10-4.486-10-10zm7.707-.293a1 1 0 1 1-1.414-1.414 1 1 0 0 1 1.414 1.414zm4.586-1.414a1 1 0 1 1 1.414 1.414 1 1 0 0 1-1.414-1.414zm-2.293 3.707c-.247 0-2.451.036-3.707 1.293a1 1 0 1 0 1.414 1.414c.57-.57 1.881-.705 2.29-.707.415.002 1.726.137 2.296.707a.998.998 0 0 0 1.707-.707 1 1 0 0 0-.293-.707c-1.256-1.257-3.46-1.293-3.707-1.293z"
  }));
};

exports.SvgSmileySadMajor = SvgSmileySadMajor;
